module.exports = __webpack_public_path__ + "static/media/error.3cd842dd.gif";